export default __webpack_public_path__ + "static/curico-logo-96ec1051eccf077558e1ae360c3e267e.png";